function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { useTheme } from '@airwallex/theme';
import { v4 as uuid } from 'uuid';
import { jsx as ___EmotionJSX } from "@emotion/core";

var withGradient = function withGradient(Component) {
  var WithGradient = function WithGradient(props) {
    var gradient = props.gradient,
        etc = _objectWithoutProperties(props, ["gradient"]);

    var theme = useTheme();

    if (gradient) {
      var GRADIENT_ID = uuid();
      return ___EmotionJSX(Component, _extends({}, etc, {
        color: "url(#".concat(GRADIENT_ID, ")")
      }), gradient === 'yellow' && ___EmotionJSX("defs", null, ___EmotionJSX("linearGradient", {
        id: GRADIENT_ID,
        x1: "0.459229",
        y1: "0",
        x2: "16.4592",
        y2: "16",
        gradientUnits: "userSpaceOnUse"
      }, ___EmotionJSX("stop", {
        stopColor: theme.colors.orange
      }), ___EmotionJSX("stop", {
        offset: "1",
        stopColor: theme.colors.yellows[50]
      }))), gradient === 'red' && ___EmotionJSX("defs", null, ___EmotionJSX("linearGradient", {
        id: GRADIENT_ID,
        x1: "0.459229",
        y1: "0",
        x2: "16.4592",
        y2: "16",
        gradientUnits: "userSpaceOnUse"
      }, ___EmotionJSX("stop", {
        stopColor: theme.colors.pinks[50]
      }), ___EmotionJSX("stop", {
        offset: "1",
        stopColor: theme.colors.red
      }))), gradient === 'pink' && ___EmotionJSX("defs", null, ___EmotionJSX("linearGradient", {
        id: GRADIENT_ID,
        x1: "0.459229",
        y1: "0",
        x2: "16.4592",
        y2: "16",
        gradientUnits: "userSpaceOnUse"
      }, ___EmotionJSX("stop", {
        stopColor: theme.colors.purples[50]
      }), ___EmotionJSX("stop", {
        offset: "1",
        stopColor: theme.colors.pinks[50]
      }))), gradient === 'purple' && ___EmotionJSX("defs", null, ___EmotionJSX("linearGradient", {
        id: GRADIENT_ID,
        x1: "0.459229",
        y1: "0",
        x2: "16.4592",
        y2: "16",
        gradientUnits: "userSpaceOnUse"
      }, ___EmotionJSX("stop", {
        stopColor: theme.colors.ultraViolet
      }), ___EmotionJSX("stop", {
        offset: "1",
        stopColor: theme.colors.purples[50]
      }))), gradient === 'spectrumOrange' && ___EmotionJSX("defs", null, ___EmotionJSX("linearGradient", {
        id: GRADIENT_ID,
        x1: "0.459229",
        y1: "0",
        x2: "16.4592",
        y2: "16",
        gradientUnits: "userSpaceOnUse"
      }, ___EmotionJSX("stop", {
        stopColor: theme.colors.red
      }), ___EmotionJSX("stop", {
        offset: "0.5",
        stopColor: theme.colors.orange
      }), ___EmotionJSX("stop", {
        offset: "1",
        stopColor: theme.colors.yellows[50]
      }))), gradient === 'spectrumPurple' && ___EmotionJSX("defs", null, ___EmotionJSX("linearGradient", {
        id: GRADIENT_ID,
        x1: "0.459229",
        y1: "0",
        x2: "16.4592",
        y2: "16",
        gradientUnits: "userSpaceOnUse"
      }, ___EmotionJSX("stop", {
        stopColor: theme.colors.ultraViolet
      }), ___EmotionJSX("stop", {
        offset: "0.5",
        stopColor: theme.colors.purples[50]
      }), ___EmotionJSX("stop", {
        offset: "1",
        stopColor: theme.colors.red
      }))), gradient === 'orange' && ___EmotionJSX("defs", null, ___EmotionJSX("linearGradient", {
        id: GRADIENT_ID,
        x1: "0.459229",
        y1: "0",
        x2: "16.4592",
        y2: "16",
        gradientUnits: "userSpaceOnUse"
      }, ___EmotionJSX("stop", {
        stopColor: theme.colors.red
      }), ___EmotionJSX("stop", {
        offset: "1",
        stopColor: theme.colors.orange
      }))));
    }

    return ___EmotionJSX(Component, etc);
  };

  WithGradient.displayName = 'withGradient(Glyphs)';
  return WithGradient;
};

export default withGradient;